import { LondonCareRecordConfigSchema } from "./londonCareRecordInstance.js";
export const CreateLondonCareRecordInstanceRequestSchema = LondonCareRecordConfigSchema.omit({ id: true });
//# sourceMappingURL=londonCareRecordInstanceRequest.js.map